import React from 'react';
import Footer from "../../common/Footer/Footer";
import Menu from "../../common/Menu/Menu";

interface HomeProps {
    children: React.ReactNode;
}

const Template: React.FC<HomeProps> = ({ children }) => {
  return (
    <>
      <Menu header_style_2={true} />
      {children}
      <Footer />
    </>
  );
};

export default Template;